module.exports = __webpack_public_path__ + "static/images/components/Nation/images/flag-all-china.45f7e865.png";


//////////////////
// WEBPACK FOOTER
// ./components/Nation/images/flag-all-china.png
// module id = 2612
// module chunks = 11